<template>
  <v-container
    v-if="items.length"
    class="py-10 py-md-13 py-lg-16 mb-10 mb-md-10 item"
  >
    <div class="text-center item-title">
      <span class="font-montserrat">PERGUNTAS</span>
      <span class="ml-4 font-audacity">frequentes</span>
    </div>

    <v-row justify="center" class="mt-8">
      <v-col cols="12" md="8" lg="7">
        <v-expansion-panels class="toggle-list" flat tile>
          <v-expansion-panel
            :class="{ 'mt-4': keyItems > 0 }"
            v-for="({ question, answer }, keyItems) in items"
            :key="keyItems"
          >
            <v-expansion-panel-header
              class="font-weight-bold"
              expand-icon="fa-plus"
            >
              {{ question }}
            </v-expansion-panel-header>
            <v-expansion-panel-content
              class="pt-4 item-text"
              v-html="answer"
            ></v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
const _config = {
  mod: "questionsAngels",
};

export default {
  created() {
    this.$rest(_config.mod).get();
  },
  computed: {
    items() {
      return this.$rest(_config.mod).list;
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  &-title {
    span {
      &:first-child {
        color: #58595b;
        font-size: 45px;
        font-weight: 700;

        @media screen and (max-width: 600px) {
          font-size: 28px;
        }
      }

      &:last-child {
        color: #76c043;
        font-size: 78px;

        @media screen and (max-width: 600px) {
          font-size: 48px;
        }
      }
    }
  }

  .toggle-list::v-deep {
    .v-expansion-panel-header {
      border: 1px solid #e1e1e1 !important;
      color: #58595b;

      &__icon {
        .v-icon {
          color: #76c043;
          font-size: 14px;
        }
      }
    }

    .v-item--active {
      .v-expansion-panel-header {
        background-color: #76c043;
        border: 1px solid #76c043 !important;
        color: white;

        .v-expansion-panel-header__icon {
          .v-icon {
            color: white;

            &:before {
              content: "\f068" !important;
            }
          }
        }
      }
    }

    .item-text {
      color: #58595b;
      font-size: 16px;
      line-height: 28px;
    }
  }
}
</style>
